export const SITE = {
  phone: '+33 6 42 25 46 26',
  phoneHref: 'tel:+33642254626',
  email: 'contact@countact.fr',
  emailHref: 'mailto:contact@countact.fr',
  // Manual fallback surfaced on the form confirmation screens when the
  // automated email gets blocked by the prospect's mail filter (MAR-1). Must
  // stay the sender mailbox — keep in sync with SES_FROM_ADDRESS, which is a
  // server-only var these client components can't read.
  leadEmail: 'camille@countact.fr',
  leadEmailHref: 'mailto:camille@countact.fr',
  location: 'Paris, Grenoble',
  facebook: 'https://www.facebook.com/countact#',
  linkedin: 'https://www.linkedin.com/company/countact/',
} as const
